
import { useI18n } from 'src/utils/lni18n';
import { useAtom } from 'jotai';
import { Link } from 'react-router-dom';
import { useCallback, useEffect, useRef, useState } from 'react';
import { coursesAtom } from '../CourseCollectionService';
import { debouncer } from 'src/utils/debouncer';

export default function AllCourses() {

    const { languageService: t } = useI18n();
    const [courseData] = useAtom(coursesAtom);
    const [searchText, setSearchText] = useState("");
    const [filteredSet, setFilteredSet] = useState(courseData);

    const textDebouncerRef = useRef<debouncer>();

 const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
 
    const doFilterCourses = useCallback( (text: string) => {
         const q = (text || '').trim();
         if (text && text.length > 1) {
            const reg = new RegExp(`${escapeRegExp(q)}.*`, "i");
            setFilteredSet({
                Courses: courseData.Courses.filter(p => reg.test(p.Name)) ?? [],
                Loading: false
            });
        } else {
            setFilteredSet(courseData);
        }
    }, [courseData]);


    useEffect(() => {
        if( textDebouncerRef.current) textDebouncerRef.current.clear();
        
        const d = new debouncer(doFilterCourses, 300);
        textDebouncerRef.current = d;

        return () => d.clear();
    }, [doFilterCourses]);

    const filterCourses = (e: React.ChangeEvent<HTMLInputElement>) => {
        const text = e.currentTarget.value;
        setSearchText(text);
        textDebouncerRef.current?.debounce(text);
    }



    return <div className="mb-5">
        <div className='mb-3'>
            <input value={searchText} type="text" onChange={(e) => filterCourses(e)}
                placeholder={t.getText("find")} className="input form-control custom-input max-col-width" />
        </div>
        <div className=''>
            {filteredSet.Courses.map((course) => (

                <div key={course.Id}>
                    <Link to={`/course/${course.Id}/general`} >
                        {course.Name}
                    </Link>
                </div>
            ))}
        </div>

    </div>






}